<ion-content class="popover_items">
    <ion-list>
        @if(modalOption.option) {
            <ion-item (click)="modalOption.option.action(); dismiss()" [detail]="false" lines="full">{{modalOption.option.label}}</ion-item>
          }
            @if(modalOption.option2) {
          <ion-item (click)="modalOption.option2.action(); dismiss()" [detail]="false" lines="full">{{modalOption.option2.label}}</ion-item>
          }
    </ion-list>
</ion-content>
